import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { clientsData } from "../data";
import "./clients.scss";
const Clients = () => {
  return (
    <div className="home-clients">
      <div className="row">
        <h1 className="big-title">
          <FormattedMessage
            id="Clients"
            defaultMessage="Our Clients"
          />
        </h1>
        <Link to="/">
          <FormattedMessage
            id="ViewAllClients"
            defaultMessage="View All Clients"
          />
        </Link>
      </div>
      <div className="flex">
        {clientsData.map((props, i) => {
          return (
            <div className="clientsCard" key={i}>
              {props.icon}
              <p className="def-text">{props.text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Clients;
